module.exports = __webpack_public_path__ + "h5/img/index3-0.a7f1ecb7.png";